
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.883 5.773c0-1.364-.268-2.372-.805-3.023-.536-.656-1.247-.984-2.133-.984-.885 0-1.596.328-2.133.984-.53.651-.796 1.659-.796 3.023V10H.75V5.805c0-1.703.375-2.982 1.125-3.836.755-.86 1.779-1.29 3.07-1.29 1.292 0 2.315.42 3.07 1.258.756.839 1.133 2.019 1.133 3.54V10H7.883V5.773z","fill":"currentColor"}})])
          )
        }
      }
    